import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { NOTIFICATIONS_NEW_CONTENT_PERMISSION_TOGGLED_GA4_EVENT } from '../../../services/event-tracking/index'

function componentFromHTML (html) {
  // eslint-disable-next-line react/no-danger
  return <p dangerouslySetInnerHTML={{ __html: html }} />
}
const NotificationRecommendedSettings = (props) => {
  const { newEpisodeNotificationsEnabled, staticText, setFeatureTrackingDataPersistent } = props

  const onSettingsChange = () => {
    setFeatureTrackingDataPersistent({
      data: Map({ newEpisodeNotificationsEnabled: !newEpisodeNotificationsEnabled }),
    })
  }

  // GA4 event
  const ga4EventData = NOTIFICATIONS_NEW_CONTENT_PERMISSION_TOGGLED_GA4_EVENT.mergeDeep({
    changed_to: !newEpisodeNotificationsEnabled ? 'on' : 'off',
  })

  return (
    <div className="my-account-settings-V2__notification-settings-controls">
      <div className="my-account-settings-V2__notification-settings-text-container">
        <div className="my-account-settings-V2__notification-settings-title">
          { staticText.getIn(['data', 'notificationsNewEpisodeHeader']) }
        </div>
        <div className="my-account-settings-V2__notification-settings-text">
          {componentFromHTML(staticText.getIn(['data', 'notificationsNewEpisodeBody']))}
        </div>
      </div>
      <div className="my-account-settings-V2__notification-settings-toggle">
        <ButtonToggle
          checked={newEpisodeNotificationsEnabled}
          onChange={onSettingsChange}
          showLabel
          ga4EventData={ga4EventData}
          round
        />
      </div>
    </div>
  )
}

NotificationRecommendedSettings.propTypes = {
  newEpisodeNotificationsEnabled: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        newEpisodeNotificationsEnabled: state.featureTracking.getIn(['data', 'newEpisodeNotificationsEnabled'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(NotificationRecommendedSettings)
